<template>
    <v-autocomplete
        v-model="selectItem"
        :items="getSelectItemsArray(field.select_items)"
        :disabled="isDisabled"
        item-text="text"
        item-value="value"
        clearable
        :rules="[isRequired ? rules.required : rules.alwaysValid]"
        :append-icon="'$vuetify.icons.dropdown'"
        :no-data-text="$t('Item_not_found')"
    >
        <template v-slot:item="data">
            <v-list-item-content style="white-space: pre-wrap; word-break: break-all" v-text="data.item" />
        </template>
    </v-autocomplete>
</template>

<script lang="ts">
// イベントを設定しているので、import追加
import { mixins } from 'vue-class-component';
import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import type { TemplateCustomizeField } from '../../store/modules/application_form_template/types';
import InputValidation from '../../mixins/InputValidation';

@Component({
    name: 'CustomizedFieldPullDown',
})
export default class CustomizedFieldPullDown extends mixins(InputValidation) {
    @Prop({ default: undefined }) readonly field: TemplateCustomizeField;
    @Prop({ default: undefined }) readonly value: string | undefined;
    @Prop({ default: false }) readonly disabled: boolean;

    // v-modelにselectItemを設定しているので、値に変更があった場合、親コンポーネントのinputイベントで変更値を設定する(immediate: trueで変更なしでも一度実行される)
    @Watch('selectItem', { immediate: true })
    onSelectItemChanged(val: string | undefined): void {
        // click:clear時にundefinedで更新されるため、空にしているとして空文字で更新する
        if (val === undefined) {
            val = '';
        }
        this.$emit('input', this.id, val);
    }

    // 初期値の設定
    selectItem: string = this.initialValue;

    /**
     * getters
     */
    get isRequired(): boolean {
        return this.field.required;
    }

    get isDisabled(): boolean {
        return this.disabled;
    }

    get initialValue(): string {
        // 値が定義なしの場合、設定値として選択項目初期値を返す
        if (this.value === undefined) {
            return this.field.default_input;
        }

        return this.value;
    }

    get id(): number {
        return this.field.id;
    }

    /**
     * methods
     */
    getSelectItemsArray(val: string): Array<string> {
        if (!val) return [];
        return val.split(',');
    }
}
</script>
